import { Routes } from '@lit-labs/router';
import { html } from 'lit';
import { ConnectAccountsController } from '../../lib/controllers/connect-accounts.js';
import { request } from '../../lib/request.js';
import { throttle } from '../../lib/throttle.js';
import { BaseElement } from '../base.js';
import './account-details.js';
import './list.js';
import './new-account-modal.js';

export class ConnectAccounts extends BaseElement {
  static properties = {
    flushing: { state: true },
    query: { state: true }
  };

  constructor() {
    super();
    this.routes = new Routes(this, [
      {
        path: ':id/*',
        render: ({ id }) => this.renderDetails(id)
      },
      {
        path: '*',
        render: () => this.renderList()
      }
    ]);
    this.accounts = null;
    this.flushing = false;
    this.query = '';
    this.throttledQuery = throttle((event) =>
      this.setQuery(event.target.value)
    );
  }

  setQuery(query) {
    this.query = query;
    this.ensureAccounts();
    this.accounts?.setSearch(query);
  }

  setPage(page_index) {
    this.ensureAccounts();
    this.accounts?.setPage(page_index);
  }

  newModal() {
    this.emit('modal:open', html`<modal-new-connect></modal-new-connect>`);
  }

  onFlush() {
    this.emit('modal:confirm', {
      description: 'Do you really want to flush the connect accounts cache?',
      confirm: async () => {
        this.flushing = true;
        try {
          await request('DELETE', '/connect-accounts');
        } finally {
          this.flushing = false;
        }
      }
    });
  }

  render() {
    return this.routes.outlet();
  }

  ensureAccounts() {
    if (!this.accounts) {
      this.accounts = new ConnectAccountsController(this);
      this.accounts.task.run();
    }
  }

  renderList() {
    this.ensureAccounts();
    return html`
      <div class="hstack">
        <h1 class="me-auto">Connect</h1>
        <button
          type="button"
          class="btn btn-sm btn-outline-warning"
          ?disabled=${this.flushing}
          @click=${this.onFlush}
        >
          Flush
        </button>
      </div>
      <shared-search-bar
        @input=${this.throttledQuery}
        value=${this.query}
      ></shared-search-bar>
      ${this.renderListContent()}
    `;
  }

  renderListContent() {
    return this.accounts?.render(({ accounts }) => {
      const { page_index, page_count } = this.accounts?.pagination || {};
      return html`
        <connect-accounts-list .items=${accounts}></connect-accounts-list>
        <shared-actions-bar>
          <button class="btn btn-sm btn-primary" @click=${this.newModal}>
            Create New
          </button>
          <shared-pagination
            class="ms-auto"
            page-count=${page_count}
            page-index=${page_index}
            @pagination:pageIndex=${(event) => this.setPage(event.detail)}
          ></shared-pagination>
        </shared-actions-bar>
      `;
    });
  }

  renderDetails(id) {
    return html`
      <connect-account-details account=${id}></connect-account-details>
    `;
  }
}

customElements.define('app-connect-accounts', ConnectAccounts);
